import { connect, MapStateToProps } from 'react-redux';
import { Props } from './DraggableProfileHero';
import { AppState } from '../../../../../types/store';
import { getSelectedCoverDeviation } from '../../../../selectors/profileHero';

export type StateProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof StateProps | 'coverDeviation'>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const coverDeviation = getSelectedCoverDeviation(state);
  return {
    coverDeviation,
  };
};

export default connect(mapStateToProps);
